import InvoiceHistory from './InvoiceHistory';

export default InvoiceHistory;
